import { BookingConditionSearch } from '../../../shared/models/api/flight';

const DEFAULT_SEAT_CLASS = 'DEFAULT';

/**
 * Tìm dòng điều kiện vé cho một mã hạng ghế.
 *
 * Khớp theo ĐUÔI DÀI NHẤT: mã hạng của hãng (vd VJ "Z1DLX", "Z1SBOSS") = tiền tố bucket
 * + họ vé admin cấu hình ("DLX", "SBOSS"). So bằng / tách "_" không còn đúng vì VJ đã bỏ
 * dấu "_" trong mã hạng. Lấy đuôi dài nhất để "SBOSS" thắng "BOSS". Mọi match so-bằng cũ
 * vẫn đúng (chuỗi endsWith chính nó) nên QH/VU/VN/9G không đổi. Không khớp → DEFAULT.
 */
export function findBookingConditionForFareClass(
  conditions: ReadonlyArray<BookingConditionSearch>,
  fareClass: string,
): BookingConditionSearch | undefined {
  const normalizedFareClass = (fareClass ?? '').toUpperCase();

  let best: BookingConditionSearch | undefined;
  let bestLength = -1;
  for (const condition of conditions) {
    for (const seatClass of condition.seatClass) {
      const normalizedSeatClass = (seatClass ?? '').toUpperCase();
      if (
        normalizedSeatClass &&
        normalizedSeatClass !== DEFAULT_SEAT_CLASS &&
        normalizedFareClass.endsWith(normalizedSeatClass) &&
        normalizedSeatClass.length > bestLength
      ) {
        best = condition;
        bestLength = normalizedSeatClass.length;
      }
    }
  }

  return (
    best ??
    conditions.find((c) => c.seatClass.includes(DEFAULT_SEAT_CLASS))
  );
}
